<spark-shared-data-table-wrapper
  [title]="title"
  [downloading]="downloading"
  (downloadClicked)="downloadClicked()">
  <ng-container table-definition>
    <div class="row" *appLoad="let data of data$">
      <div class="col">
        <div class="row mb-3">
          <div class="col">
            <ngx-datatable
              [rows]="data.data"
              [columns]="columns"
              [reorderable]="true"
              [swapColumns]="false"
              rowHeight="auto"
              columnMode="force"
              *ngIf="data">
              <ngx-datatable-column name="Client type">
                <ng-template let-row="row" ngx-datatable-cell-template>
                  {{ row.type }}
                </ng-template>
              </ngx-datatable-column>
              <ngx-datatable-column name="Name">
                <ng-template let-row="row" ngx-datatable-cell-template>
                  {{
                    [
                      row.title,
                      [row.firstName, row.middleName, row.lastName]
                        | join: ' ':true
                    ] | join: '. ':true
                  }}
                </ng-template>
              </ngx-datatable-column>
              <ngx-datatable-column name="Mobile">
                <ng-template let-value="value" ngx-datatable-cell-template>
                  {{ value }}
                </ng-template>
              </ngx-datatable-column>
              <ngx-datatable-column name="Email">
                <ng-template let-value="value" ngx-datatable-cell-template>
                  {{ value }}
                </ng-template>
              </ngx-datatable-column>
              <ngx-datatable-column name="DOB">
                <ng-template let-value="value" ngx-datatable-cell-template>
                  {{ value }}
                </ng-template>
              </ngx-datatable-column>
            </ngx-datatable>
          </div>
        </div>
        <div class="row">
          <div class="col d-flex justify-content-end">
            <spark-shared-pagination
              [currentPage]="data.pagination.currentPage"
              [size]="data.pagination.pageSize"
              [count]="data.pagination.totalItems"
              (gotoPage)="
                pageChanged($event, data.pagination.pageSize)
              "></spark-shared-pagination>
          </div>
        </div>
      </div>
    </div>
  </ng-container>
</spark-shared-data-table-wrapper>
